import { EntityType } from '../../../../types/comment';
import { CustomFieldValue } from '../../../../types/custom_field/customField';
import { MetricInterval } from '../../../../types/metrics/metricFilter';
import { FlowType } from '../../../../types/order/orderFlow';
import { TaskStatus, TaskType } from '../../../../types/task';

export enum FilterStorageKey {
  STOCK_LOCATION_ROLE_ASSIGMENT = 'STOCK_LOCATION_ROLE_ASSIGNMENT',
  STOCK_LOCATION = 'STOCK_LOCATION',
  TASK = 'TASK',
  ORDER = 'ORDER',
  PRODUCT_TRANSACTION = 'PRODUCT_TRANSACTION',
  BIN_FOR_TASK = 'BIN_FOR_TASK',
  PRODUCT_FOR_TASK = 'PRODUCT_FOR_TASK',
  PRODUCT = 'PRODUCT',
  BIN = 'BIN',
  PRODUCT_MASTER_DATA = 'PRODUCT_MASTER_DATA',
  CONTACT = 'CONTACT',
  SHIPPING_LOCATION = 'SHIPPING_LOCATION',
  USER = 'USER',
  REORDER_RULE = 'REORDER_RULE',
  REORDER_USER_RULE = 'REORDER_USER_RULE',
  BIN_STATUS = 'BIN_STATUS',
  SCAN_CONFIGURATION = 'SCAN_CONFIGURATION',
  SCAN_RULE = 'SCAN_RULE',
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  INTEGRATION_SETTINGS = 'INTEGRATION_SETTINGS',
  REORDER_RULE_PRODUCT = 'REORDER_RULE_PRODUCT',
  TRIGGER = 'TRIGGER',
  ALERT = 'ALERT',
  FILE = 'FILE',
  TRANSLATION = 'TRANSLATION',
  CONTAINER = 'CONTAINER',
  LOT = 'LOT',
  ASSET = 'ASSET',
  ASSET_TRANSACTION = 'ASSET_TRANSCTION',
  HANDLING_UNIT = 'HANDLING_UNIT',
  KIT_TEMPLATE = 'KIT_TEMPLATE',

  BIN_CONSTRAINT = 'BIN_CONSTRAINT',
  COMPANY_PARTNER = 'COMPANY_PARTNER',

  COMPANY_CUSTOMER = 'COMPANY_CUSTOMER',

  MANAGE_TYPE = 'MANAGE_TYPE',
}

export interface FilterParameters {
  type?: FilterStorageKey;
  startDate?: string;
  endDate?: string;
  taskStatus?: TaskStatus[];
  orderStatus?: string[];
  orderType?: FlowType[];
  taskType?: TaskType[];
}

export interface EntityTimeFrame {
  start: Date;
  end: Date;
  interval?: MetricInterval;
}

type SortDirection = 'asc' | 'desc';

export class FilterProps {
  query?: string;
  pageIndex?: number;
  sortBy?: string;
  sortDirection?: SortDirection;

  // For filtering
  timeFrame?: EntityTimeFrame;
  staticTimeFrame?: string;

  stockLocation?: Set<string>;
  sourceStockLocation?: Set<string>;
  destinationStockLocation?: Set<string>;

  taskStatus?: Set<string>;
  taskType?: Set<string>;

  orderStatus?: Set<string>;
  orderType?: Set<string>;

  country?: Set<string>;
  bin?: Set<string>;
  binStatus?: Set<string>;
  product?: Set<string>;
  user?: Set<string>;
  role?: Set<string>;
  lot?: Set<string>;
  container?: Set<string>;
  containerType?: Set<string>;

  serialManaged?: boolean;
  lotManaged?: boolean;
  lpnManaged?: boolean;

  fileTypeCategory?: Set<string>;
  fileType?: Set<string>;

  tags?: Map<EntityType, Set<string>>;

  customField?: Set<string>;
  customFieldValues?: Map<string, Set<CustomFieldValue['value']> | undefined>;
  customFieldType?: Set<string>;
  customFieldEntityType?: Set<string>;
  customFieldEntitySubType?: Set<string>;

  assetTransactionStatus?: Set<string>;
  assetCreatedAt?: EntityTimeFrame;
  assetSignedAt?: EntityTimeFrame;

  binConstraints?: Set<string>;

  company?: Set<string>;

  companyStatus?: Set<string>;

  manageType?: Set<string>;

  constructor(timeFrame?: EntityTimeFrame, staticTimeFrame?: string) {
    this.timeFrame = timeFrame;
    this.staticTimeFrame = staticTimeFrame;
  }
}

export function getFilterCount(filter: FilterProps) {
  let count = 0;
  for (const [key, value] of Object.entries(filter)) {
    if (key === 'query') continue;
    if (value) count++;
  }

  return count;
}

export function getSaveFilter(entity: FilterStorageKey | undefined): string | null {
  if (!entity) return null;
  return localStorage.getItem(`filter_${entity.toString()}`);
}

export function storeSavedFilter(entity: FilterStorageKey, filter: string) {
  return localStorage.setItem(`filter_${entity.toString()}`, filter);
}

export function replacer(key: any, value: any) {
  if (value instanceof Map) {
    return {
      dataType: 'Map',
      value: Array.from(value.entries()),
    };
  } else if (value instanceof Set) {
    return {
      dataType: 'Set',
      value: Array.from(value.values()),
    };
  } else {
    return value;
  }
}

export function reviver(key: any, value: any) {
  if (typeof value === 'object' && value !== null) {
    if (value.dataType === 'Map') {
      return new Map(value.value);
    } else if (value.dataType === 'Set') {
      return new Set(value.value);
    }
  }
  return value;
}
